<template>
  <v-card :loading="loading" class="elevation-12">
    <v-card-title>{{ $t('importRegistry.title') }}</v-card-title>
    <v-card-text>
      <v-form>
        <v-combobox :disabled="form.isTemplateNameFromExcel" v-model="form.templateName" :items="templateNameOptions" dense :label="$t('importRegistry.templateTypeLabel')"
                    :error-messages="templateNameErrors"/>
        <v-checkbox
            v-model="form.isTemplateNameFromExcel"
            :label="$t('importRegistry.selectViaExcelLabel')"
            color="darken-3"
        ></v-checkbox>
        <v-file-input v-model="form.file"
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      :show-size="true"
                      :label="$t('importRegistry.selectFileLabel')"
                      @blur="$v.form.file.$touch()"
                      :error-messages="fileErrors"
        />
        <v-textarea v-model="form.note" :label="$t('importRegistry.noteLabel')" filled :auto-grow="true" @blur="$v.form.note.$touch()"/>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn color="success" :disabled="$v.form.$invalid" @click="onImportButtonClicked">{{ $t('importRegistry.importBtn') }}</v-btn>
    </v-card-actions>

    <v-snackbar v-model="overLimit"
                :timeout="5000"
                :top="true"
                color="error"
    >
      {{ $t('importRegistry.limitExceededSnack') }}
    </v-snackbar>
  </v-card>
</template>

<script>
import XLSX from "xlsx";
import {required} from "vuelidate/lib/validators";
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "../../../store/modules/layout/actions";
import TemplateService from "@/services/template.service";
import RegistryService from "@/services/registry.service";

export default {
  name: "ImportRegistryComponent",
  data() {
    return {
      loading: false,
      isCreateFailed: false,

      form: {
        isTemplateNameFromExcel: false,
        note: '',
        file: null,
        templateName: null,
      },
      templateNameOptions: [],
      overLimit: false,
    }
  },
  validations: {
    form: {
      file: {
        required: required
      },
      templateName: {
        required
      },
      note: {}
    }
  },
  computed: {
    fileErrors() {
      const errors = []

      if (this.$v.form.file.$dirty) {
        if (!this.$v.form.file.required)
          errors.push(this.$t('importRegistry.fileRequiredError'))
      }

      return errors
    },
    templateNameErrors() {
      const errors = []

      if (this.$v.form.templateName.$dirty) {
        if (!this.$v.form.templateName.required)
          errors.push(this.$t('importRegistry.templateRequiredError'))
      }

      return errors
    }
  },
  methods: {
    async getTemplateNameOptions() {
      try {
        const response = await TemplateService.getTemplates({organizationId: this.$store.getters.appLogin.organization.id});
        return response.data;
      } catch (error) {
        console.error('Error fetching template code options:', error);
        throw error;
      }
    },
    onImportButtonClicked() {
      if (!this.form.templateName && !this.form.isTemplateNameFromExcel) {
        console.error('Invalid templateName or note');
        return;
      }
      this.$store.dispatch(LAYOUT_LOADING_START);

      const reader = new FileReader();

      reader.onload = (e) => {
        const xlsx = XLSX.read(e.target.result, {
          type: 'binary',
          cellDates: true,
          cellNF: false,
          cellText: false
        });

        const firstSheet = xlsx.Sheets[xlsx.SheetNames[0]];
        const firstSheetData = XLSX.utils.sheet_to_json(firstSheet, {
          dateNF: 'dd"."mm"."yyyy',
          raw: false
        });

        const keys = Object.keys(firstSheetData[0]);
        if (firstSheetData.length > 500) {
          this.overLimit = true;
          this.$store.dispatch(LAYOUT_LOADING_STOP);
          return;
        }

        let requestContent = TemplateService.mapTemplate(this.form.templateName.text, keys, firstSheetData, this.form.isTemplateNameFromExcel)

        RegistryService.create(requestContent)
            .then(response => {
              this.$store.dispatch(LAYOUT_LOADING_STOP)
              const registry = response.data

              this.$router.push({name: 'mails-listing-draft', params: {id: registry.id}})
            }, () => {
              this.isServerError = true
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
            .finally(() => {
              this.$store.dispatch(LAYOUT_LOADING_STOP);
            });
      };

      reader.onerror = () => {
        console.error('Error reading file:', reader.error);
        this.$store.dispatch(LAYOUT_LOADING_STOP);
      };

      // Check if this.form.file is valid before reading
      if (!this.form.file) {
        console.error('Invalid file');
        this.$store.dispatch(LAYOUT_LOADING_STOP);
        return;
      }

      reader.readAsBinaryString(this.form.file);
    }
  },
  async created() {
    try {
      this.loading = true;
      const response = await this.getTemplateNameOptions();
      this.templateNameOptions = response.map(template => ({
        id: template.Id,
        text: template.Name,
      }));
    } catch (error) {
      console.error('Error fetching template code options:', error);
    } finally {
      this.loading = false;
    }
  },
}
</script>

<style scoped>

</style>